import React, { PropTypes } from "react";
import _ from "lodash";
import { connect } from "react-redux";

import { BASE_IMAGES_URL } from "Constants";
import { confirmAlert } from "react-confirm-alert";
import { Badge } from "react-bootstrap";
import { showSuccess } from "ReduxErrorBar";
import Button from "react-bootstrap-button-loader";
import {
  toggleActivateDeactivateChallenge,
  fetchManageChallengesList,
  loadEditchallengesData,
  openChallengesModal,
} from "ManagechallengesActions";

import LocaleStrings from "Languages";

class ManageChallengesItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  // Toggle Active / Deactivate
  activeDeactivateClick = (param1, param2) => {
    var id = param1;
    var isactive = param2 == 1 ? 0 : 1;

    confirmAlert({
      title: LocaleStrings.gamification_chooser_toogle_challenge_title,
      message: LocaleStrings.gamification_chooser_toogle_challenge_message,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            //this.props.session
            this.props.toggleActivateDeactivateChallenge(
              this.props.session,
              id,
              isactive,
              (CallBackResponse) => {
                if (CallBackResponse.success) {
                  this.props.showSuccess(
                    LocaleStrings.gamification_toggle_form_success
                  );

                  if (
                    this.props.managechallengesSelectedTab ==
                    "MANAGECHALLENGES_SINGLE"
                  ) {
                    // Single Challenge
                    this.props.fetchManageChallengesList(
                      this.props.session,
                      this.props.searchKey,
                      "single",
                      (CallBackResponse) => {}
                    );
                  } else {
                    // For Recurring Chaleenges call
                    this.props.fetchManageChallengesList(
                      this.props.session,
                      this.props.searchKey,
                      "recurring",
                      (CallBackResponse) => {}
                    );
                  }
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  // Modal Call function
  editChallengeCallback(obj) {
    var challenges = this.props.Item;
    this.props.loadEditchallengesData(challenges);
    this.props.openChallengesModal({
      showModal: true,
      idFieldName: challenges.id,
      idFieldLable: challenges.id,
    });
  }

  render() {
    var { Item } = this.props;
    var { isadmin } = this.props.Item;
    var { appuserid } = this.props.Item;
    var { position } = this.props.position;
    var { searchKey } = this.props.searchKey;

    var selectedUsers = this.props.selectedUsers;
    var user = this.props.Item;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === user.appuserid;
    });

    var checked = false;
    if (index >= 0) {
      checked = true;
    }
    var profileImageUrl = "../../style/images/custom-icons/user_2.png";

    if (
      this.props.Item.profileurl &&
      this.props.Item.profileurl !== "" &&
      this.props.Item.profileurl !== null
    ) {
      profileImageUrl = `${BASE_IMAGES_URL}/${this.props.Item.profileurl}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    }

    var style = {
      width: "30px",
      height: "30px",
      backgroundImage: `url(${profileImageUrl})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "10px",
      backgroundPosition: "50% 50%",
    };

    return (
      <tr
        id={this.props.Item.appuserid}
        style={checked ? { backgroundColor: "#fff" } : {}}
      >
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 14, paddingTop: 3 }}
          >
            <div className="vcenter">{this.props.Item.challengename} </div>
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 14, paddingTop: 3 }}
          >
            <div className="vcenter">{this.props.Item.challengetype} </div>
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 14, paddingTop: 3 }}
          >
            <div className="vcenter">{this.props.Item.challengedesc} </div>
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 14, paddingTop: 3 }}
          >
            <div className="vcenter">
              <Badge
                bg="primary"
                className={
                  this.props.Item.showpopup == 1
                    ? "gamifi-bg-success"
                    : "gamifi-bg-danger"
                }
              >
                {this.props.Item.showpopup == 1 ? "Yes" : "No"}
              </Badge>{" "}
            </div>
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 14, paddingTop: 3 }}
          >
            <div className="vcenter ">
              <span className="points-text">
                {this.props.Item.points}
                {" pts"}
              </span>
            </div>
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 14, paddingTop: 3 }}
          >
            <div className="action-button vcenter" style={{ width: "150px" }}>
              <button
                className="btn btn-custom-table-white"
                onClick={this.editChallengeCallback.bind(this)}
              >
                Edit
              </button>{" "}
              <Button
                id={this.props.Item.id}
                type="button"
                onClick={() =>
                  this.activeDeactivateClick(
                    this.props.Item.id,
                    this.props.Item.isactive
                  )
                }
                className={
                  this.props.Item.isactive == 1
                    ? "btn gamifi-btn-custom-success"
                    : "btn gamifi-btn-custom-danger"
                }
              >
                {" "}
                {this.props.Item.isactive == 1 ? "Active" : "Deactivate"}{" "}
              </Button>{" "}
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  var { session, managechallengesSelectedTab } = state;

  return {
    session: state.session,
    managechallengesSelectedTab,
  };
};

export default connect(mapStateToProps, {
  showSuccess,
  toggleActivateDeactivateChallenge,
  fetchManageChallengesList,
  loadEditchallengesData,
  openChallengesModal,
})(ManageChallengesItem);
